/**
 * @license @tabler/icons-react v3.44.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

const __iconNode = [["path", { "d": "M11 7l-5 5l5 5", "key": "svg-0" }], ["path", { "d": "M17 7l-5 5l5 5", "key": "svg-1" }]];
const IconChevronsLeft = createReactComponent("outline", "chevrons-left", "ChevronsLeft", __iconNode);

export { __iconNode, IconChevronsLeft as default };
//# sourceMappingURL=IconChevronsLeft.mjs.map
